

import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    components: {

    },
})

export default class CustomButton extends Vue {
    @Prop({ type: Boolean, default: false }) readonly isOutlined!: boolean;

    click() {
        this.$emit('click');
    }
    // outlinedClass: string = this.isOutlined ? 'outlined-button' : 'filled-button'

}
